import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { initSentry } from "./src/lib/sentry";
import { initPostHog } from "./src/lib/posthog";
import AppRoot from "./src/AppRoot";
import "./src/styles/globals.css";

// Initialize Sentry FIRST (error tracking must be ready before anything else)
initSentry();

// Initialize PostHog analytics (autocapture, session replay, web vitals)
initPostHog();

createRoot(document.getElementById("root")!).render(
  <StrictMode data-oid="fibck.o">
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p style={{ color: '#666', marginTop: '0.5rem' }}>
            The application encountered an unexpected error. Please refresh the page.
          </p>
        </div>
      )}
    >
      <AppRoot data-oid=".gm:2le" />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
